//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Http from "../utils/http";
import Action from "../action";
import FormPanel from "../components/panels/form";
export default {
  components: {
    "panels-form": FormPanel
  },
  props: {
    spec: {
      type: Object,
      required: true
    },
    // Original spec. It might be different from the latest spec (after reloading).
    stack: {
      type: Array,
      required: true
    },
    vueApp: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      title: null,
      message: null,
      body: null,
      footer: null,
      model: null,
      url: null,
      urlLoaded: false,
      showClose: false,
      isFormDirty: false,
      isFormSubmitted: false,
      isMobile: false,
      formSpec: null
    };
  },
  computed: {
    containerComponent: function containerComponent() {
      if (this.formSpec) {
        return "panels-form";
      }

      return "div";
    },
    fullscreen: function fullscreen() {
      if (this.spec.fullscreen == "mobile" && this.isMobile) {
        return true;
      } else if (this.spec.fullscreen == "always") {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    model: function model(val, oldVal) {
      if (!val) {
        this.$destroy();
      }
    }
  },
  methods: {
    $ready: function $ready() {
      this.$root.vueApp = this.vueApp;
      this.onResize();
      this.show(false);
      this.stack.push(this);
    },
    $tearDown: function $tearDown() {
      console.log("Dialog destroyed");
      this.stack.remove(this);
    },
    close: function close() {
      if (Utils.http.proceedEvenWhenDirty()) {
        this.model = false;
      }
    },
    click: function click(spec, event) {
      var onClick = spec["onClick"];
      this.model = false;
      Action.execute(onClick, this);
    },
    reload: function reload(newSpec) {
      if (Utils.http.proceedEvenWhenDirty()) {
        this.spec = newSpec;
        this.urlLoaded = false;
        this.show(true);
      }
    },
    onResize: function onResize() {
      this.isMobile = window.innerWidth < 600;
    },
    show: function show(reload) {
      var _this = this;

      var spec = this.spec;
      this.url = spec.url;
      this.showClose = Utils.type.isString(this.url);

      if (Utils.type.isString(this.url)) {
        if (!this.urlLoaded) {
          if (!reload) {
            this.message = "Loading...";
          }

          var url = Utils.url.appendParams(this.url, {
            _dialog: "v1"
          });
          Http.execute({
            url: url
          }, "GET", this, function (response) {
            Utils.http.forceComponentUpdate(function () {
              _this.urlLoaded = true;
              _this.title = response.title;
              _this.message = "";
              _this.formSpec = response.fullPageForm;
              _this.body = response.body;
              _this.footer = response.footer;
              _this.showClose = _this.spec.showClose || false;
            });
          });
        }
      } else {
        this.title = this.spec.title;
        this.message = this.spec.message;
        this.body = this.spec.body;
        this.showClose = this.spec.showClose || false;
        Action.execute(spec.onLoad, this);
      }

      this.model = true;
    }
  }
};